import { render } from "./InterviewNav.vue?vue&type=template&id=5fa76170&scoped=true"
import script from "./InterviewNav.vue?vue&type=script&lang=js"
export * from "./InterviewNav.vue?vue&type=script&lang=js"

import "./InterviewNav.vue?vue&type=style&index=0&id=5fa76170&scoped=true&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa76170"]])

export default __exports__